module.exports = __webpack_public_path__ + "img/Dantam Fashion 06.c2ef2b49.jpg";